import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  whiteColor: {
    color: theme.palette.common.white,
  },
  video: {
    margin: '0 auto',
  },
  infoBox: {
    display: 'flex',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#7833FF',
    borderRadius: theme.spacing(1),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0),
    },
  },
  infoBoxItem: {
    flexBasis: '33.33%',
    padding: theme.spacing(2),
    color: theme.palette.common.white,

    '& img': {
      height: 60,
      marginBottom: theme.spacing(1),
    },
  },
}));
